import React from 'react';
import {Box, Card, CardContent, Chip, Drawer, IconButton, Stack, Typography,} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import getCheckboxDisplayLabel from '../../../../utility/getCheckboxDisplayLabel';

/* eslint-disable react/prop-types */
const GroupDrawer = ({open, onClose, formName, groups = []}) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
        >
            <Box
                sx={{
                    width: {
                        xs: '100vw',
                        sm: 450
                    },
                    height: '100%',
                    overflowY: 'auto',
                    padding: 3,
                    boxSizing: 'border-box'
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center">
                    <Typography variant="h6" fontWeight="bold">
                        Groups Created from This Form
                    </Typography>
                    <IconButton onClick={onClose}><CloseIcon/></IconButton>
                </Box>
                <Typography variant="body2" color="text.secondary" marginBottom={2}>
                    Groups that have been created based on responses from <strong>{formName}</strong>
                </Typography>
                <Stack spacing={2}>
                    {groups.map((group, i) => (
                        <Card key={i} variant="outlined">
                            <CardContent>
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight="bold"
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        {
                                            group.isMyGroup
                                                ? <GroupIcon fontSize="small"/>
                                                : <SchoolIcon fontSize="small"/>
                                        }
                                        {group.name}
                                    </Typography>
                                    <Chip label={group.isMyGroup ? 'My Group' : 'School Group'} size="small"/>
                                </Box>
                                <Typography variant="body2" mt={1}>
                                    <strong>Question:</strong> {group.linkedForm.question}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Answer:</strong> {group.linkedForm.questionType === 'checkboxQuestion'
                                    ? getCheckboxDisplayLabel(group.linkedForm.answer)
                                    : group.linkedForm.answer}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </Stack>
            </Box>
        </Drawer>
    );
};

export default GroupDrawer;
